import u from "./ui.module.css";

export default function Field({
  label,
  hint,
  error,
  children,
  className = "",
}) {
  return (
    <div className={`${u.field} ${className}`}>
      {label ? <label className={u.label}>{label}</label> : null}
      {children}
      {hint && !error ? <span className={u.hint}>{hint}</span> : null}
      {error ? <span className={u.errorText}>{error}</span> : null}
    </div>
  );
}

export function Input({ error, className = "", ...rest }) {
  return (
    <input
      className={`${u.input} ${error ? u.inputError : ""} ${className}`}
      {...rest}
    />
  );
}

export function Select({ error, className = "", children, ...rest }) {
  return (
    <select
      className={`${u.select} ${error ? u.inputError : ""} ${className}`}
      {...rest}
    >
      {children}
    </select>
  );
}

export function Textarea({ error, className = "", ...rest }) {
  return (
    <textarea
      className={`${u.textarea} ${error ? u.inputError : ""} ${className}`}
      {...rest}
    />
  );
}
